import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user'])
}



// WEBPACK FOOTER //
// ./src/app/tenant/common-area/resources/computed.js